module.exports = __webpack_public_path__ + "assets/img/gd4.1c6c7ed4.jpg";